/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAufgabeTerminVorschauDto } from '../../models/lexplus-aufgabe-termin-vorschau-dto';

export interface AufgabenControllerPreviewTerminV1$Params {
  id: number;
}

export function aufgabenControllerPreviewTerminV1(http: HttpClient, rootUrl: string, params: AufgabenControllerPreviewTerminV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAufgabeTerminVorschauDto>> {
  const rb = new RequestBuilder(rootUrl, aufgabenControllerPreviewTerminV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAufgabeTerminVorschauDto>;
    })
  );
}

aufgabenControllerPreviewTerminV1.PATH = '/v1/aufgaben/{id}/termin-vorschau';
